import Vue from "vue";

export default {
    setQueryData: async ({commit}, queryData) => {
        commit('setQueryData', queryData)
    },
    setQueryDataSites: async ({commit}, queryData) => {
        commit('setQueryDataSites', queryData)
    },
    getDtpQueriesReport: async ({commit}) => {
        let config = {
            method: 'get',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/dtp-query-report',
            headers: {
                'Content-Type': 'application/json'
            },
            params: {}
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Get dtp queries response: ', response)

                    if (response.data.errorMessage) {
                        return Error(response.data.errorMessage)
                    } else if (response.data.type && response.data.type === 'error') {
                        return Error(response.data.message)
                    }else if (response.status === 200) {
                        commit('setReport', response.data)
                    }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    setSelectedQueryProject: async ({commit, dispatch}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'get',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/dtp-queries',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {projectId: selectedProject._id}
            };
            return await Vue.prototype.$http(config)
                .then(async (response) => {
                    console.log('Get processing project response: ', response)

                    if (response.data.errorMessage) {
                        return Error(response.data.errorMessage)
                    } else if (response.data.type && response.data.type === 'error') {
                        return Error(response.data.message)
                    }else if (response.status === 200) {
                        commit('setSelectedQueryProject', selectedProject)
                        commit('setSelectedQuerySite', null)
                        commit('setDtpQueries', response.data.bySite)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setSelectedQueryProject', null)
            commit('setSelectedQuerySite', null)
            commit('setDtpQueries', [])
        }
    },
    setSelectedQuerySite: async ({commit, dispatch}, selectedSite) => {
        if (selectedSite) {
            let config = {
                method: 'get',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/dtp-queries',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {siteId: selectedSite._id}
            };
            return await Vue.prototype.$http(config)
                .then(async (response) => {
                    console.log('Get processing project response: ', response)

                    if (response.data.errorMessage) {
                        return Error(response.data.errorMessage)
                    } else if (response.data.type && response.data.type === 'error') {
                        return Error(response.data.message)
                    }else if (response.status === 200) {
                        commit('setSelectedQueryProject', null)
                        commit('setSelectedQuerySite', selectedSite)
                        commit('setDtpQueries', [response.data])
                    }

                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setSelectedQuerySite', null)
            commit('setSelectedQueryProject', null)
            commit('setDtpQueries', [])
        }
    },
    updateDtpQueries: async ({commit, dispatch}, dtpQueries) => {

            let config = {
                method: 'post',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/dtp-queries',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {queries: dtpQueries}
            };
            return await Vue.prototype.$http(config)
                .then(async (response) => {
                    console.log('Update dtp queries response: ', response)

                    if (response.data.errorMessage) {
                        return Error(response.data.errorMessage)
                    } else if (response.data.type && response.data.type === 'error') {
                        return Error(response.data.message)
                    }else if (response.status === 200) {
                        await dispatch('getDtpQueriesReport')
                        if(response.data && response.data.queries){
                            commit('mergeUpdatedDtpQueries', response.data.queries)
                        }
                    }

                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
    },
    getFileUrl: async ({commit, dispatch}, payload) => {

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/dtp-file-url',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then(async (response) => {
                console.log('Get dtp file url: ', response)

                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }else if (response.status === 200) {
                    console.log('Get dtp file url: ', response)
                }

                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },


}

